import { createNanoEvents } from 'nanoevents'
import { SEMEvents } from './event-bus'

export const $eventBus = createNanoEvents<SEMEvents>()
